<div class="shell">
  <aside class="sidebar">
    <div class="brand">
      <div class="brand-copy">
        <p class="brand-title">XlhireEsigns</p>
        <p class="brand-sub">eSignature Workspace</p>
      </div>
    </div>

    <div class="sidebar-body">
      <div class="quick-access" data-quick-access>
        <button
          type="button"
          class="btn-pill-action quick-access-trigger"
          aria-haspopup="menu"
          [attr.aria-expanded]="quickAccessOpen"
          (click)="toggleQuickAccess()"
        >
          <div class="btn-pill-inner">
            <span class="btn-pill-icon-wrapper">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
            </span>
            <span>Create New</span>
          </div>
        </button>

        @if (quickAccessOpen) {
          <div class="quick-access-menu" role="menu" aria-label="Quick access menu">
            <a routerLink="/documents/new" role="menuitem" (click)="closeQuickAccess()">
              <span class="menu-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                </svg>
              </span>
              <span>
                <strong>New Document</strong>
                <small>Send a new agreement for signature.</small>
              </span>
            </a>
            <a routerLink="/templates/new" role="menuitem" (click)="closeQuickAccess()">
              <span class="menu-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="3" y1="9" x2="21" y2="9"></line>
                  <line x1="9" y1="21" x2="9" y2="9"></line>
                </svg>
              </span>
              <span>
                <strong>New Template</strong>
                <small>Start from a reusable signing layout.</small>
              </span>
            </a>
          </div>
        }
      </div>

      <nav class="nav">
        <a
          routerLink="/dashboard"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="7" height="9"></rect>
            <rect x="14" y="3" width="7" height="5"></rect>
            <rect x="14" y="12" width="7" height="9"></rect>
            <rect x="3" y="16" width="7" height="5"></rect>
          </svg>
          <span>DASHBOARD</span>
        </a>
        
        <div
          class="nav-group nav-group-collapsible"
          [class.active]="isDocumentsRoute()"
          [class.expanded]="isDocumentsNavExpanded()"
        >
          <button
            type="button"
            class="nav-group-toggle"
            aria-controls="documents-nav-links"
            [attr.aria-expanded]="isDocumentsNavExpanded()"
            (click)="toggleDocumentsNav()"
          >
            <span class="nav-group-title-inner">
              <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
              </svg>
              <span>DOCUMENTS</span>
            </span>
            <svg class="caret-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>

          @if (isDocumentsNavExpanded()) {
            <div class="nav-group-links" id="documents-nav-links">
              <a routerLink="/documents" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">My Documents</a>
              <a routerLink="/documents/drafts" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Drafts</a>
              <a routerLink="/documents/trash" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Trash</a>
            </div>
          }
        </div>

        <a routerLink="/templates" routerLinkActive="active">
          <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="3" y1="9" x2="21" y2="9"></line>
            <line x1="9" y1="21" x2="9" y2="9"></line>
          </svg>
          <span>TEMPLATES</span>
        </a>

        <div
          class="nav-group nav-group-collapsible"
          [class.active]="isApiRoute()"
          [class.expanded]="isApiNavExpanded()"
        >
          <button
            type="button"
            class="nav-group-toggle"
            aria-controls="api-nav-links"
            [attr.aria-expanded]="isApiNavExpanded()"
            (click)="toggleApiNav()"
          >
            <span class="nav-group-title-inner">
              <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="16 18 22 12 16 6"></polyline>
                <polyline points="8 6 2 12 8 18"></polyline>
              </svg>
              <span>API</span>
            </span>
            <svg class="caret-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>

          @if (isApiNavExpanded()) {
            <div class="nav-group-links" id="api-nav-links">
              <a routerLink="/api-management/api-key" routerLinkActive="active">API Key</a>
              <a routerLink="/api-management/webhooks" routerLinkActive="active">Webhooks</a>
              <a routerLink="/api-management/sender-identities" routerLinkActive="active">Sender Identities</a>
            </div>
          }
        </div>

        <div
          class="nav-group nav-group-collapsible"
          [class.active]="isSettingsRoute()"
          [class.expanded]="isSettingsNavExpanded()"
        >
          <button
            type="button"
            class="nav-group-toggle"
            aria-controls="settings-nav-links"
            [attr.aria-expanded]="isSettingsNavExpanded()"
            (click)="toggleSettingsNav()"
          >
            <span class="nav-group-title-inner">
              <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
              </svg>
              <span>SETTINGS</span>
            </span>
            <svg class="caret-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>

          @if (isSettingsNavExpanded()) {
            <div class="nav-group-links" id="settings-nav-links">
              <a routerLink="/settings/profile" routerLinkActive="active">My Profile</a>
              <a routerLink="/settings/branding" routerLinkActive="active">Branding</a>
            </div>
          }
        </div>
      </nav>

      <div class="sidebar-footer">
        <button type="button" class="logout-btn" (click)="logout()" [disabled]="loggingOut">
          <svg class="logout-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          <span>{{ loggingOut ? 'Signing out…' : 'LOGOUT' }}</span>
        </button>
      </div>
    </div>
  </aside>

  <div class="main-layout">
    <header class="app-header">
      <div class="header-greeting">
        @if (authSession.currentUser(); as user) {
          <span>Welcome back 👋 <strong>{{ user.name }}</strong></span>
        } @else {
          <span>Welcome back 👋</span>
        }
      </div>
      
      @if (authSession.currentUser(); as user) {
        <div class="profile-card">
          <div class="profile-avatar">
            {{ getUserInitials() }}
          </div>
          <div class="profile-details">
            <p class="profile-name">{{ user.name }}</p>
            <p class="profile-role">Manager HR</p>
          </div>
        </div>
      }
    </header>

    <main class="content">
      <router-outlet />
    </main>
  </div>
</div>
